module.exports = __webpack_public_path__ + "static/media/smallDeliveryTruck_tomato.fe40cc1b.svg";